import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { FirebaseAuthService } from './firebaseauth.service';
import { UserDetail } from '@app/interface/auth.user';
import { StudiesService } from './studies.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SentNotifications } from '@app/interface/sentNotifications';

@Injectable({
  providedIn: 'root',
})
export class SentNotificationsService {
  constructor(
    private store: AngularFirestore,
    private afAuth: AngularFireAuth,
    private authService: FirebaseAuthService,
    private studiesService: StudiesService
  ) {}

  public getSentNotificationsByStudyId(): Observable<any> {
    let studyId = this.studiesService.getStudyId();
    console.log('Study id is' + studyId);
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection<SentNotifications>('sent-notifications', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).orderBy('sentDate', 'desc');
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }
}
